exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".location-chooser{padding:20px}.location-chooser h2,.location-chooser p{text-align:center}.location-chooser .input-area{margin:0 0 20px 0;background-color:#fff}.location-chooser .input-area>input{border:0;width:calc(100% - 20px);border-radius:3px;margin:0 10px 0 10px;outline:0px}.location-chooser .input-area .MuiOutlinedInput-input{padding:15px 14px}.location-chooser .input-area .MuiOutlinedInput-notchedOutline{border-color:var(--primary-brand-colour)}.location-chooser .input-area .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{border-color:var(--primary-brand-colour)}", ""]);

// exports
